// src/utils/obfuscate.js

// Simple reversible obfuscation for numeric IDs
export function encodeId(id) {
    if (!id && id !== 0) return '';
    const val = (Number(id) * 73) + 109;
    const str = String(val);
    return btoa(str).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}

export function decodeId(obfuscated) {
    if (!obfuscated) return null;
    try {
        let str = obfuscated.replace(/-/g, '+').replace(/_/g, '/');
        while (str.length % 4) {
            str += '=';
        }
        const decodedStr = atob(str);
        const val = Number(decodedStr);
        if (isNaN(val)) return null;
        const id = (val - 109) / 73;
        return Number.isInteger(id) ? id : null;
    } catch (e) {
        return null;
    }
}
